module.exports = __webpack_public_path__ + "static/media/rtask.c0985227.png";